import {HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export const UnwrapInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    return next(request).pipe(
        map(event => {
            if (event instanceof HttpResponse && event.body) {
                const body: any = event.body;
                if (body.value) {
                    return event.clone({ body: body.value });
                }
            }
            return event;
        })
    );
}
